export default (emailConfigs) => {
  const procEmailConfigs = [];
  emailConfigs.results.forEach((emailConf) => {
    const formattedEmail = `${emailConf.sender_name || ''} (${emailConf.email})`;
    procEmailConfigs.push({ id: emailConf.id, formattedEmail, is_primary: emailConf.is_primary });
  });
  return procEmailConfigs;
};
